/*
 * @Author: your name
 * @Date: 2022-04-07 16:22:59
 * @LastEditTime: 2022-04-14 15:34:51
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /Luckytu-sign-h5/src/main.ts
 */
import { createApp } from 'vue'
import App from './App.vue'
import vantUse from './vant'
import 'vant/lib/index.css'
import './assets/style/comment.less'
import './assets/style/global.less'
import router from './router'
import store from './store'
import Request from '@/utils/request'
import VueAxios from 'vue-axios'

const app = createApp(App as any)

vantUse(app)

app.use(VueAxios,Request.init()).use(store).use(router).mount('#app')
